import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { OrganizationEditForm } from "@/features/organization/OrganizationEditForm";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";

export function OrganizationEdit() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/organization",
            label: "Organization",
          },
          {
            label: "Edit",
          },
        ]}
      />
      <H2>Edit Organization</H2>
      <OrganizationEditForm id={id} />
    </>
  );
}
